<template>
  <b-tabs
    :value="activeTab"
    class="o-tabs"
    :destroy-on-hide="destroyOnHide"
    position="is-centered"
    type="is-toggle"
    @input="selectTab"
  >
    <b-tab-item v-for="item in tabItems" :key="item.name" :value="item.name" :label="item.label">
      <slot :name="item.name" />
    </b-tab-item>
  </b-tabs>
</template>

<script>
export default {
  name: 'OTabs',

  props: {
    items: {
      type: Array,
      required: true,
      validator: (items) =>
        items.every((item) => typeof item === 'string' || (item.label && item.name)),
    },
    destroyOnHide: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      tab: null,
    }
  },

  created() {
    this.tab = this.resolveTab(this.$route.params.tab)
  },

  computed: {
    tabItems() {
      return this.items.map((item, index) =>
        typeof item === 'string' ? { label: item, name: String(index) } : item,
      )
    },

    isRouted() {
      return typeof this.items[0] !== 'string'
    },

    activeTab() {
      return this.isRouted ? this.resolveTab(this.$route.params.tab) : this.tab
    },
  },

  methods: {
    resolveTab(tab) {
      const name = String(tab)

      return this.tabItems.some((item) => item.name === name) ? name : this.tabItems[0].name
    },

    selectTab(name) {
      if (!this.isRouted) {
        this.tab = name
        return
      }

      const tab = name === this.tabItems[0].name ? undefined : name
      if (tab === this.$route.params.tab) {
        return
      }

      this.$router.push({ name: this.$route.name, params: { ...this.$route.params, tab } })
    },
  },
}
</script>

<style lang="scss">
.o-tabs {
  .tab-content {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
